import { ReturnButton } from "_components";
import { FilterCreateForm } from ".";

export { FiltersAddEdit };

function FiltersAddEdit() {

    return(
        <div>
            <div className="ml-10 pl-12">
                <ReturnButton from={'addEdit'}/>
            </div>                           
            <div className="p-12 col-span-3 h-full">                    
                <FilterCreateForm />
            </div>
        </div>
    )
} 